import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { SupportRoutingModule } from './support-routing.module';

import {MatListModule} from '@angular/material/list'; 
import { SupportComponent } from './support.component';


@NgModule({
  declarations: [
    SupportComponent
  ],
  imports: [
    CommonModule,
    SupportRoutingModule,
    MatListModule
  ]
})
export class SupportModule { }
